import React, { useCallback, useMemo, memo } from 'react';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';

// Imports => Utilities
import { AcUUID } from '@utils';

// Imports => Atoms
import AcRichContent from '@atoms/ac-rich-content/ac-rich-content.web';

const _CLASSES = {
	MAIN: 'ac-action-participants-list',
	LIST: 'ac-action-participants-list__list',
	ITEM: 'ac-action-participants-list__item',
	MORE: 'ac-action-participants-list__item--more',
	INITIALS: 'ac-action-participants-list__initials',
	NAME: 'ac-action-participants-list__name',
};

const AcActionParticipantsList = ({
	id = null,
	collection,
	max = false,
	className,
	history,
}) => {
	const getNameClassNames = useMemo(() => {
		return clsx(_CLASSES.NAME);
	}, []);

	const getInitialsClassNames = useMemo(() => {
		return clsx(_CLASSES.INITIALS);
	}, []);

	const getMoreClassNames = useMemo(() => {
		return clsx(_CLASSES.ITEM, _CLASSES.MORE);
	}, []);

	const getItemClassNames = useMemo(() => {
		return clsx(_CLASSES.ITEM);
	}, []);

	const getListClassNames = useMemo(() => {
		return clsx(_CLASSES.LIST);
	}, []);

	const getMainClassNames = useMemo(() => {
		return clsx(_CLASSES.MAIN);
	}, []);

	const getInitials = useCallback(
		name => {
			if (!name) return null;

			const arr = name.split(' ');
			const first_letter = arr[0][0];
			let last_letter = arr.length > 1 ? arr[arr.length - 1][0] : arr[0][1];

			if (last_letter === '(') {
				last_letter = arr[arr.length - 2][0];
			}

			return `${first_letter}${last_letter}`;
		},
		[collection]
	);

	const renderParticipants = useMemo(() => {
		let list = collection;

		if (max) {
			list = list.slice(0, max);
		}

		const col_len = collection.length;
		const len = list.length;
		let n = 0;
		let result = [];

		for (n; n < len; n++) {
			const key = list[n];

			const object = (
				<div key={key} className={getItemClassNames}>
					<div className={getInitialsClassNames}>{getInitials(key)}</div>
					<div className={getNameClassNames}>{key}</div>
				</div>
			);

			result.push(object);
		}

		if (col_len > len) {
			const diff = Math.abs(col_len - len);

			const more = (
				<div key={AcUUID()} className={getMoreClassNames}>
					{`+ ${diff} deelnemer${diff > 1 ? 's' : ''}`}
				</div>
			);

			result.push(more);
		}

		return result;
	}, [collection]);

	const renderNoParticipants = useMemo(() => {
		return (
			<AcRichContent content={'<p>Er zijn nog geen deelnemers bekend.</p>'} />
		);
	}, [collection]);

	return (
		<div className={getMainClassNames}>
			<div className={getListClassNames}>
				{collection && collection.length > 0 && renderParticipants}
				{!collection || (collection.length === 0 && renderNoParticipants)}
			</div>
		</div>
	);
};

export default withRouter(memo(AcActionParticipantsList));
